var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    { staticClass: "round-trip-panel", attrs: { value: 0 } },
    [
      _c(
        "v-expansion-panel-content",
        { staticClass: "round-trip-panel-content" },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("h4", [_vm._v(_vm._s(_vm.$t("roundtrip.roundtripOptions")))])
          ]),
          _vm._v(" "),
          [
            _c("fields-container", {
              attrs: { parameters: _vm.roundTripFilterAccessor.props },
              on: { fieldUpdated: _vm.filterUpdated }
            })
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd101374", { render: render, staticRenderFns: staticRenderFns })
  }
}